import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api-integracao-os';
import stylesformulario from "./formulario-styles.module.css";
import stylesprintformulario from "./printformulario-styles.module.css";
import swalstyles from "./swal-styles.module.css";
import loadingstyles from "./loading-styles.module.css";
import { useHistory } from "react-router-dom";
import fileDownload from 'js-file-download';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select, { components } from 'react-select';

import { BsSearch, BsFillXCircleFill } from 'react-icons/bs';
import { GoAlert } from 'react-icons/go';

export default function IntegracaoOs() {
    const [loading, setLoading] = useState(true);
    const [printing, setPrinting] = useState(false);
    const [loadingAfterPrint, setLoadingAfterPrint] = useState(false);
    const [searching, setSearching] = useState(false);

    const [editarFornecedor, setEditarFornecedor] = useState(false);
    const [capaFormulario, setCapaFormulario] = useState({});
    const [empresa, setEmpresa] = useState({});
    const [inputEmail, setInputEmail] = useState('');
    const [inputTelefone, setInputTelefone] = useState('');
    const [inputEndereco, setInputEndereco] = useState('');

    const [modalSearchFornecedor, setModalSearchFornecedor] = useState(false);
    const [searchingFornecedor, setSearchingFornecedor] = useState(false);
    const [inputSearchFornecedor, setInputSearchFornecedor] = useState(null);
    const [inputDescricaoSearchFornecedor, setInputDescricaoSearchFornecedor] = useState('');
    const [inputCnpjSearchFornecedor, setInputCnpjSearchFornecedor] = useState('');
    const [listFornecedor, setListFornecedor] = useState([]);
    const [fornecedor, setFornecedor] = useState({});
    const [inputIEFornecedor, setInputIEFornecedor] = useState('');
    const [inputEmailFornecedor, setInputEmailFornecedor] = useState('');
    const [inputTelefoneFornecedor, setInputTelefoneFornecedor] = useState('');
    const [inputEnderecoFornecedor, setInputEnderecoFornecedor] = useState('');

    const [modalSearchOrdemServ, setModalSearchOrdemServ] = useState(false);
    const [searchingOrdemServ, setSearchingOrdemServ] = useState(false);
    const [inputSearchOrdemServ, setInputSearchOrdemServ] = useState(null);
    const [inputFrotaSearchOrdemServ, setInputFrotaSearchOrdemServ] = useState('');
    const [inputDataInicialSearchOrdemServ, setInputDataInicialSearchOrdemServ] = useState('');
    const [inputDataFinalSearchOrdemServ, setInputDataFinalSearchOrdemServ] = useState('');
    const [listOrdemServ, setListOrdemServ] = useState([]);
    const [ordemServ, setOrdemServ] = useState({});
    const [inputObservacaoOs, setInputObservacaoOs] = useState('');

    const [modalSearchProduto, setModalSearchProduto] = useState(false);
    const [searchingProduto, setSearchingProduto] = useState(false);
    const [inputSearchProduto, setInputSearchProduto] = useState(null);
    const [inputDescricaoSearchProduto, setInputDescricaoSearchProduto] = useState('');
    const [listProdutos, setListProdutos] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [selectedProdutos, setSelectedProdutos] = useState([]);

    const [modalSearchTransportador, setModalSearchTransportador] = useState(false);
    const [searchingTransportador, setSearchingTransportador] = useState(false);
    const [inputSearchTransportador, setInputSearchTransportador] = useState(null);
    const [inputDescricaoSearchTransportador, setInputDescricaoSearchTransportador] = useState('');
    const [inputCnpjSearchTransportador, setInputCnpjSearchTransportador] = useState('');
    const [listTransportador, setListTransportador] = useState([]);
    const [transportador, setTransportador] = useState({});
    const [inputCidadeUfTransportador, setInputCidadeUfTransportador] = useState('');
    const [inputTelefoneTransportador, setInputTelefoneTransportador] = useState('');
    const [inputVeiculoTransportador, setInputVeiculoTransportador] = useState('');
    const [inputPlacaTransportador, setInputPlacaTransportador] = useState('');
    const [inputNomeMotoristaTransportador, setInputNomeMotoristaTransportador] = useState('');
    const [inputCpfMotoristaTransportador, setInputCpfMotoristaTransportador] = useState('');
    const [inputTelefoneMotoristaTransportador, setInputTelefoneMotoristaTransportador] = useState('');
    const [inputNomeResponsavelFrete, setInputNomeResponsavelFrete] = useState('');
    const [selectResponsavelFrete, setSelectResponsavelFrete] = useState({
        items: [
            { value: 0, label: 'REMETENTE'},
            { value: 1, label: 'DESTINATÁRIO'}
        ],
        selectItem: 0,
    });
    const [selectTipoFrete, setSelectTipoFrete] = useState({
        items: [
            { value: 0, label: 'SEM FRETE'},
            { value: 1, label: 'FRETE PRÓPRIO'},
            { value: 2, label: 'FRETE TERCEIRIZADO'}
        ],
        selectItem: 2,
    });

    let history = useHistory();

    useEffect(() => {
        if(loading) {
            if(!history.location.state || (history.location.state && !history.location.state.hasAccess)) {
                history.push('/integracaoos');
            } else if(history.location.state.id_formulario_os_capa) {
                api.get(`/formulario/getformulario?id_formulario_os_capa=${history.location.state.id_formulario_os_capa}`).then(response => {
                    if (response.data.error) {
                        console.log(response.data.error);
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'OCORREU UM ERRO INESPERADO!',
                            text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                            icon: 'error',
                        }).then(() => {
                            history.push('/integracaoos');
                        });
                    } else if(response.data.result) {
                        // Capa
                        setCapaFormulario(response.data.result.capa);
                        // Empresa
                        setEmpresa(response.data.result.empresa);
                        setInputEmail(response.data.result.empresa.email || '');
                        setInputTelefone(response.data.result.empresa.telefone || '');
                        setInputEndereco(response.data.result.empresa.endereco || '');
                        // Destinatario
                        setFornecedor(response.data.result.destinatario);
                        setInputIEFornecedor(response.data.result.destinatario.inscricao_estadual || '');
                        setInputEmailFornecedor(response.data.result.destinatario.email || '');
                        setInputTelefoneFornecedor(response.data.result.destinatario.telefone || '');
                        setInputEnderecoFornecedor(response.data.result.destinatario.endereco || '');
                        // OS
                        if([0].includes(response.data.result.capa.tipo)) {
                            setOrdemServ(response.data.result.os);
                            setInputObservacaoOs(response.data.result.os.observacao_os);
                        }
                        // Produtos
                        setSelectedProdutos(response.data.result.produtos);
                        // Transportador
                        setTransportador(response.data.result.transportador);
                        setInputCidadeUfTransportador(response.data.result.transportador.cidade_uf);
                        setInputTelefoneTransportador(response.data.result.transportador.telefone);
                        setInputVeiculoTransportador(response.data.result.transportador.veiculo);
                        setInputPlacaTransportador(response.data.result.transportador.placa);
                        setInputNomeMotoristaTransportador(response.data.result.transportador.nome_motorista);
                        setInputCpfMotoristaTransportador(maskCpfCnpj(response.data.result.transportador.cpf_motorista));
                        setInputTelefoneMotoristaTransportador(response.data.result.transportador.telefone_motorista);
                        setSelectTipoFrete(changeSelectValue(selectTipoFrete, response.data.result.transportador.tipo_frete));
                        setSelectResponsavelFrete(changeSelectValue(selectResponsavelFrete, response.data.result.transportador.responsavel_frete));
                        setInputNomeResponsavelFrete(response.data.result.transportador.nome_responsavel_frete);
                    }
                }).catch(err => {
                    // handle error
                    console.log(err);
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'NÃO FOI POSSÍVEL CONCLUIR A REQUISIÇÃO!',
                        text: 'POR FAVOR, TENTE NOVAMENTE MAIS TARDE',
                        icon: 'error',
                    }).then(() => {
                        history.push('/integracaoos');
                    });
                }).finally(() => {
                    setLoading(false);
                });
            } else {
                api.get(`/formulario/newformulario?id_empresa=${parseInt(localStorage.empresa_id)}&tipo_os=${history.location.state.tipo_os}`).then(response => {
                    if (response.data.error) {
                        console.log(response.data.error);
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'OCORREU UM ERRO INESPERADO!',
                            text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                            icon: 'error',
                        }).then(() => {
                            history.push('/integracaoos');
                        });
                    } else if(response.data.result) {
                        setCapaFormulario(response.data.result.capa);
                        setEmpresa(response.data.result.empresa);
                        setInputEndereco(response.data.result.empresa.endereco || '');
                    }
                }).catch(err => {
                    // handle error
                    console.log(err);
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'NÃO FOI POSSÍVEL CONCLUIR A REQUISIÇÃO!',
                        text: 'POR FAVOR, TENTE NOVAMENTE MAIS TARDE',
                        icon: 'error',
                    }).then(() => {
                        history.push('/integracaoos');
                    });
                }).finally(() => {
                    setLoading(false);
                });
            }
        }
    }, []);


    useEffect(() => {
        if(history.location.state && history.location.state.id_formulario_os_capa && ordemServ.codigo) {
            setSearchingProduto(true);

            searchFromCHB(
                [
                    {key: 'codigo', value: ordemServ.codigo},
                    {key: 'codigo_frota', value: ''},
                    {key: 'data_abertura_inicial', value: ''},
                    {key: 'data_abertura_final', value: ''},
                ], empresa.id, 'os'
            ).then(result => {
                if(result.affectedRows) {
                    setProdutos(
                        result.result[0].produtos.map(produto => {
                            return ({
                                codigo: produto.codigo,
                                descricao: produto.descricao,
                                unidade_medida: produto.unidade_medida,
                                peso: null,
                                cfop: null,
                                quantidade: produto.quantidade,
                                valor_unitario: produto.valor_unitario,
                            })
                        })
                    );
                }

                setSearchingProduto(false);
            });
        }
    }, [ordemServ]);
    
    useEffect(() => {
        if(loading || printing || modalSearchFornecedor || modalSearchOrdemServ || modalSearchProduto || modalSearchTransportador) {
            document.body.classList.add(swalstyles.blockbody);
        }
        else {
            document.body.classList.remove(swalstyles.blockbody);
        }
    }, [loading, printing, modalSearchFornecedor, modalSearchOrdemServ, modalSearchProduto, modalSearchTransportador]);

    function handleAfterPrint(id_formulario_os_capa) {
        setLoadingAfterPrint(true);

        setEditarFornecedor(false);
        setCapaFormulario({});
        setEmpresa({});
        setInputEmail('');
        setInputTelefone('');
        setInputEndereco('');
        setFornecedor({});
        setInputIEFornecedor('');
        setInputEmailFornecedor('');
        setInputTelefoneFornecedor('');
        setInputEnderecoFornecedor('');
        setOrdemServ({});
        setInputObservacaoOs('');
        setProdutos([]);
        setSelectedProdutos([]);
        setTransportador({});
        setInputCidadeUfTransportador('');
        setInputTelefoneTransportador('');
        setInputVeiculoTransportador('');
        setInputPlacaTransportador('');
        setInputNomeMotoristaTransportador('');
        setInputCpfMotoristaTransportador('');
        setInputTelefoneMotoristaTransportador('');
        setInputNomeResponsavelFrete('');

        api.get(`/formulario/getformulario?id_formulario_os_capa=${id_formulario_os_capa}`).then(response => {
            if (response.data.error) {
                console.log(response.data.error);
                Swal.fire({
                    customClass: {
                        container: swalstyles.swalcontainer,
                        popup: swalstyles.swalbackground
                    },
                    title: 'OCORREU UM ERRO INESPERADO!',
                    text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                    icon: 'error',
                }).then(() => {
                    history.push('/integracaoos');
                });
            } else if(response.data.result) {
                // Capa
                setCapaFormulario(response.data.result.capa);
                // Empresa
                setEmpresa(response.data.result.empresa);
                setInputEmail(response.data.result.empresa.email || '');
                setInputTelefone(response.data.result.empresa.telefone || '');
                setInputEndereco(response.data.result.empresa.endereco || '');
                // Destinatario
                setFornecedor(response.data.result.destinatario);
                setInputIEFornecedor(response.data.result.destinatario.inscricao_estadual || '');
                setInputEmailFornecedor(response.data.result.destinatario.email || '');
                setInputTelefoneFornecedor(response.data.result.destinatario.telefone || '');
                setInputEnderecoFornecedor(response.data.result.destinatario.endereco || '');
                // OS
                if([0].includes(response.data.result.capa.tipo)) {
                    setOrdemServ(response.data.result.os);
                    setInputObservacaoOs(response.data.result.os.observacao_os);
                }
                // Produtos
                setSelectedProdutos(response.data.result.produtos);
                // Transportador
                setTransportador(response.data.result.transportador);
                setInputCidadeUfTransportador(response.data.result.transportador.cidade_uf);
                setInputTelefoneTransportador(response.data.result.transportador.telefone);
                setInputVeiculoTransportador(response.data.result.transportador.veiculo);
                setInputPlacaTransportador(response.data.result.transportador.placa);
                setInputNomeMotoristaTransportador(response.data.result.transportador.nome_motorista);
                setInputCpfMotoristaTransportador(maskCpfCnpj(response.data.result.transportador.cpf_motorista));
                setInputTelefoneMotoristaTransportador(response.data.result.transportador.telefone_motorista);
                setSelectTipoFrete(changeSelectValue(selectTipoFrete, response.data.result.transportador.tipo_frete));
                setSelectResponsavelFrete(changeSelectValue(selectResponsavelFrete, response.data.result.transportador.responsavel_frete));
                setInputNomeResponsavelFrete(response.data.result.transportador.nome_responsavel_frete);
            }
        }).catch(err => {
            // handle error
            console.log(err);
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'NÃO FOI POSSÍVEL CONCLUIR A REQUISIÇÃO!',
                text: 'POR FAVOR, TENTE NOVAMENTE MAIS TARDE',
                icon: 'error',
            }).then(() => {
                history.push('/integracaoos');
            });
        }).finally(() => {
            setLoadingAfterPrint(false);
        });
    }

    function Theme(theme) {
        return ({
            ...theme,
            colors: {
                ...theme.colors,
                primary: '#d4d4d4', // CHOOSED
                primary50: '#e7e7e7', // CLICK
                primary25: '#f3f3f3', // HOVER
            }
        })
    }

    function Option(props) {
         if(['select_produto'].includes(props.selectProps.inputId)) {
            return (
                <components.Option {...props}>
                    <div style={{textAlign: 'left', fontWeight: 500}}>
                        <div>{props.data.codigo} - {props.data.descricao}</div>
                    </div>
                </components.Option>
            )
        }
    }

    function FilterOptions(candidate, input) {
        return (`${candidate.data.codigo} - ${candidate.data.descricao}`).toLowerCase().includes(input.toLowerCase());
    }

    function handleToastShow(message) {
        Swal.fire({
            customClass: {
                container: swalstyles.swaltoastconteiner,
                popup: swalstyles.swaltoastpopup,
                htmlContainer: swalstyles.swaltoasttext,
                icon: swalstyles.swaltoasticon,
                timerProgressBar: swalstyles.swaltoastprogressbar,
            },
            position: 'top-right',
            toast: true,
            text: message,
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            icon: 'info',
        });
    }

    function removeMask(value) {
        return value.replace(/[^0-9]/g, '');
    }

    function maskCpfCnpj(value) {
        const newValue = value.replace(/[^0-9]/g, '');

        const regex = (newValue.length < 11) ? /^(\d)/ : (newValue.length < 12) ? /^(\d{3})(\d{3})(\d{3})(\d{2})/ : (newValue.length < 13) ? /^(\d{2})(\d{3})(\d{3})(\d{4})/ : /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/;
        const regexText = (newValue.length < 11) ? '$1' : (newValue.length < 12) ? '$1.$2.$3-$4' : (newValue.length < 13) ? '$1.$2.$3/$4' : '$1.$2.$3/$4-$5';

        return newValue.replace(regex, regexText);
    }

    function validaCpfCnpj(cpf_cnpj) {
        return (/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/).test(cpf_cnpj) || (/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/).test(cpf_cnpj)
    }

    function redirect_empresa_os(id_empresa) {
        const redirect = {
            1: 'cooper-02',
            2: 'cooper-02',
            20: 'cooper-02',
            5: 'cooper-06',
            6: 'cooper-06',
            3: 'crv-02',
            4: 'crv-02',
            7: 'crv-06',
            8: 'crv-06',
        }

        return redirect[id_empresa];
    }

    function redirect_empresa_padrao(id_empresa) {
        const redirect = {
            1: 'cooper-01',
            2: 'cooper-02',
            20: 'cooper-02',
            5: 'cooper-01',
            6: 'cooper-02',
            3: 'crv-01',
            4: 'crv-01',
            7: 'crv-01',
            8: 'crv-01',
        }

        return redirect[id_empresa];
    }

    function generatePostOptions(arrayOptions, id_empresa, path) {
        var myHeaders = new Headers();
        myHeaders.append("x-api-key", process.env.REACT_APP_API_SEARCH_CHB_KEY);
        myHeaders.append("Content-Type", "application/json");
        var raw = {};

        if(path === 'os') {
            raw.empresa = redirect_empresa_os(id_empresa);
            raw.emp_forn = [1, 2, 5, 6].includes(id_empresa) ? 2 : 1;
        } else if(path === 'produtos') {
            raw.empresa = redirect_empresa_padrao(id_empresa);
        } else if(path === 'fornecedores') {
            raw.empresa = redirect_empresa_padrao(id_empresa);
        }

        arrayOptions.forEach(option => {
            raw[option.key] = option.value;
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(raw),
            redirect: 'follow'
        };

        return requestOptions;
    }

    async function searchFromCHB(args, empresa_id, path) {
        var returnData = {};
        var requestOptions = generatePostOptions(args, empresa_id, path);

        await fetch(`${process.env.REACT_APP_API_SEARCH_CHB_URL}/controladoria/${path}/listagem`, requestOptions).then(response => response.json()).then(result => {
            if (!result.success) {
                console.log(result);
                Swal.fire({
                    customClass: {
                        container: swalstyles.swalcontainer,
                        popup: swalstyles.swalbackground
                    },
                    title: 'OCORREU UM ERRO INESPERADO!',
                    text: result.msg,
                    icon: 'error',
                }).then(() => {});
            } else {
                returnData = result.data;
            }
        }).catch(error => {
            console.log(error);
            Swal.fire({
                customClass: {
                    container: swalstyles.swalcontainer,
                    popup: swalstyles.swalbackground
                },
                title: 'NÃO FOI POSSÍVEL CONCLUIR A REQUISIÇÃO!',
                text: 'POR FAVOR, TENTE NOVAMENTE MAIS TARDE',
                icon: 'error',
            }).then(() => {});
        });

        return returnData;
    }

    function searchFornecedorByCodigo() {
        if(inputSearchFornecedor && !searchingFornecedor) {
            setSearchingFornecedor(true);
            setFornecedor({});
            setInputIEFornecedor('');
            setInputEmailFornecedor('');
            setInputTelefoneFornecedor('');
            setInputEnderecoFornecedor('');
            removeAlertErro('inputIEFornecedor');
            removeAlertErro('inputEmailFornecedor');
            removeAlertErro('inputTelefoneFornecedor');
            removeAlertErro('inputEnderecoFornecedor');

            searchFromCHB(
                [
                    {key: 'codigo', value: inputSearchFornecedor},
                    {key: 'descricao', value: ''},
                    {key: 'cnpj', value: ''},
                ], empresa.id, 'fornecedores'
            ).then(result => {
                if(!result.affectedRows) {
                    handleToastShow('Nenhum Registro foi encontrado!');
                } else {
                    setInputSearchFornecedor(null);
                    setFornecedor({
                        codigo: result.result[0].codigo,
                        descricao: result.result[0].descricao,
                        cnpj: result.result[0].cnpj,
                    });

                    setInputIEFornecedor(result.result[0].inscricao_estadual || '');
                    setInputEmailFornecedor(result.result[0].email || '');
                    setInputTelefoneFornecedor(result.result[0].telefone || '');
                    setInputEnderecoFornecedor(`${result.result[0].logradouro ? result.result[0].logradouro : ''}${result.result[0].logradouro && ((result.result[0].cidade && result.result[0].uf) || result.result[0].cep) ? '; ' : ''}${result.result[0].cidade && result.result[0].uf ? `${result.result[0].cidade}-${result.result[0].uf}` : ''}${result.result[0].cidade && result.result[0].uf && result.result[0].cep ? ', ' : ''}${result.result[0].cep ? `CEP: ${result.result[0].cep}` : ''}`);
                }
            }).finally(() => {
                setSearchingFornecedor(false);
            });
        }
    }

    function searchListFornecedor() {
        if(!searching) {
            if(inputDescricaoSearchFornecedor && inputDescricaoSearchFornecedor.length < 3) {
                handleToastShow('Digite ao menos 3 caracteres para pesquisar por descrição!');
            } else if(inputCnpjSearchFornecedor && !validaCpfCnpj(inputCnpjSearchFornecedor)) {
                handleToastShow('CPF/CNPJ informado é inválido!');
            } else if(inputSearchFornecedor || inputDescricaoSearchFornecedor || inputCnpjSearchFornecedor) {
                setSearching(true);
                setListFornecedor([]);

                searchFromCHB(
                    [
                        {key: 'codigo', value: inputSearchFornecedor || 0},
                        {key: 'descricao', value: inputDescricaoSearchFornecedor},
                        {key: 'cnpj', value: removeMask(inputCnpjSearchFornecedor)},
                    ], empresa.id, 'fornecedores'
                ).then(result => {
                    if(result.affectedRows) {
                        setListFornecedor(result.result);
                    }
                }).finally(() => {
                    setSearching(false);
                });
            }
        }
    }

    function searchTransportadorByCodigo() {
        if(inputSearchTransportador && !searchingTransportador) {
            setSearchingTransportador(true);
            setTransportador({});
            setInputCidadeUfTransportador('');
            setInputTelefoneTransportador('');
            setInputVeiculoTransportador('');
            setInputPlacaTransportador('');
            removeAlertErro('inputCidadeUfTransportador');
            removeAlertErro('inputTelefoneTransportador');
            removeAlertErro('inputVeiculoTransportador');
            removeAlertErro('inputPlacaTransportador');

            removeAlertErro('inputNomeResponsavelFrete');
            removeAlertErro('inputNomeMotoristaTransportador');
            removeAlertErro('inputCpfMotoristaTransportador');
            removeAlertErro('inputTelefoneMotoristaTransportador');

            searchFromCHB(
                [
                    {key: 'codigo', value: inputSearchTransportador},
                    {key: 'descricao', value: ''},
                    {key: 'cnpj', value: ''},
                ], empresa.id, 'fornecedores'
            ).then(result => {
                if(!result.affectedRows) {
                    handleToastShow('Nenhum Registro foi encontrado!');
                } else {
                    setInputSearchTransportador(null);
                    setTransportador({
                        codigo: result.result[0].codigo,
                        descricao: result.result[0].descricao,
                        cnpj: result.result[0].cnpj,
                    });
                    setInputCidadeUfTransportador(result.result[0].cidade && result.result[0].uf ? `${result.result[0].cidade}-${result.result[0].uf}` : '');
                    setInputTelefoneTransportador(result.result[0].telefone || '');
                }
            }).finally(() => {
                setSearchingTransportador(false);
            });
        }
    }

    function searchListTransportador() {
        if(!searching) {
            if(inputDescricaoSearchTransportador && inputDescricaoSearchTransportador.length < 3) {
                handleToastShow('Digite ao menos 3 caracteres para pesquisar por descrição!');
            } else if(inputCnpjSearchTransportador && !validaCpfCnpj(inputCnpjSearchTransportador)) {
                handleToastShow('CPF/CNPJ informado é inválido!');
            } else if(inputSearchTransportador || inputDescricaoSearchTransportador || inputCnpjSearchTransportador) {
                setSearching(true);
                setListTransportador([]);

                searchFromCHB(
                    [
                        {key: 'codigo', value: inputSearchTransportador || 0},
                        {key: 'descricao', value: inputDescricaoSearchTransportador},
                        {key: 'cnpj', value: removeMask(inputCnpjSearchTransportador)},
                    ], empresa.id, 'fornecedores'
                ).then(result => {
                    if(result.affectedRows) {
                        setListTransportador(result.result);
                    }
                }).finally(() => {
                    setSearching(false);
                });
            }
        }
    }

    function searchOrdemServByCodigo() {
        if(inputSearchOrdemServ && !searchingOrdemServ) {
            setSearchingOrdemServ(true);
            setSearchingProduto(true);
            setOrdemServ({});
            setInputObservacaoOs('');
            setProdutos([]);
            setSelectedProdutos([]);
            removeAlertErro('selectedProdutos');
            removeAlertErro('inputUfFrotaOrdemServ');

            searchFromCHB(
                [
                    {key: 'codigo', value: inputSearchOrdemServ},
                    {key: 'codigo_frota', value: ''},
                    {key: 'data_abertura_inicial', value: ''},
                    {key: 'data_abertura_final', value: ''},
                ], empresa.id, 'os'
            ).then(result => {
                if(!result.affectedRows) {
                    handleToastShow('Nenhum Registro foi encontrado!');
                } else {
                    setInputSearchOrdemServ(null);
                    setOrdemServ({
                        codigo: result.result[0].codigo,
                        data_abertura: moment(result.result[0].data_abertura, 'YYYY MM DDTHH mm ss').format('YYYY-MM-DD'),
                        centro_custo: result.result[0].centro_custo,
                        solicitante: result.result[0].solicitante,
                        frota: {
                            codigo: result.result[0].frota_codigo,
                            descricao: result.result[0].frota_descricao,
                            placa: result.result[0].frota_placa,
                            chassi: result.result[0].frota_chassi,
                            proprietario: result.result[0].frota_proprietario,
                            uf_placa: result.result[0].uf_placa
                        }
                    });

                    setProdutos(
                        result.result[0].produtos.map(produto => {
                            return ({
                                codigo: produto.codigo,
                                descricao: produto.descricao,
                                unidade_medida: produto.unidade_medida,
                                peso: null,
                                cfop: null,
                                quantidade: produto.quantidade,
                                valor_unitario: produto.valor_unitario,
                            })
                        })
                    );

                    if(!result.result[0].produtos.length) {
                        document.getElementById('selectedProdutos').classList.add(stylesprintformulario.carderro);
                    }
                }
            }).finally(() => {
                setSearchingOrdemServ(false);
                setSearchingProduto(false);
            });
        }
    }

    function searchListOrdemServ() {
        if(!searching) {
            if(inputFrotaSearchOrdemServ && inputFrotaSearchOrdemServ.length !== 5) {
                handleToastShow('Códigos de frota possuem 5 caracteres!');
            } else if(inputFrotaSearchOrdemServ && (!inputDataInicialSearchOrdemServ || !inputDataFinalSearchOrdemServ)) {
                handleToastShow('Informe um período para pesquisar por frota!');
            } else if((inputDataInicialSearchOrdemServ || inputDataFinalSearchOrdemServ) && !moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').isValid()) {
                handleToastShow('A data inicial é inválida!');
            } else if((inputDataInicialSearchOrdemServ || inputDataFinalSearchOrdemServ) && !moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY').isValid()) {
                handleToastShow('A data final é inválida!');
            } else if(moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').isAfter(moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY'))) {
                handleToastShow('A data inicial deve ser anterior a data final!');
            } else if(moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').add(3, 'month').isBefore(moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY'))) {
                handleToastShow('Existe um limite de 3 meses na faixa de pesquisa por data!');
            } else if(inputSearchOrdemServ || (inputFrotaSearchOrdemServ && inputDataInicialSearchOrdemServ && inputDataFinalSearchOrdemServ) || (inputDataInicialSearchOrdemServ && inputDataFinalSearchOrdemServ)) {
                setSearching(true);
                setListOrdemServ([]);

                searchFromCHB(
                    [
                        {key: 'codigo', value: inputSearchOrdemServ || 0},
                        {key: 'codigo_frota', value: inputFrotaSearchOrdemServ},
                        {key: 'data_abertura_inicial', value: inputDataInicialSearchOrdemServ},
                        {key: 'data_abertura_final', value: inputDataFinalSearchOrdemServ},
                    ], empresa.id, 'os'
                ).then(result => {
                    if(result.affectedRows) {
                        setListOrdemServ(result.result);
                    }
                }).finally(() => {
                    setSearching(false);
                });
            }
        }
    }

    function searchProdutoByCodigo() {
        if(inputSearchProduto && !searchingProduto) {
            setSearchingProduto(true);
            setProdutos([]);

            searchFromCHB(
                [
                    {key: 'codigo', value: inputSearchProduto},
                    {key: 'descricao', value: ''},
                ], empresa.id, 'produtos'
            ).then(result => {
                if(!result.affectedRows) {
                    handleToastShow('Nenhum Registro foi encontrado!');
                } else {
                    setInputSearchProduto(null);
                    
                    let newObj = Object.assign([], selectedProdutos);

                    newObj.push({
                        codigo: result.result[0].codigo,
                        descricao: result.result[0].descricao,
                        unidade_medida: result.result[0].unidade_medida,
                        peso: null,
                        cfop: null,
                        quantidade: 0,
                        valor_unitario: 0,
                    });

                    setSelectedProdutos(newObj);
                }
            }).finally(() => {
                setSearchingProduto(false);
            });
        }
    }

    function searchListProduto() {
        if(!searching) {
            if(inputDescricaoSearchProduto && inputDescricaoSearchProduto.length < 3) {
                handleToastShow('Digite ao menos 3 caracteres para pesquisar por descrição!');
            } else if(inputSearchProduto || inputDescricaoSearchProduto) {
                setSearching(true);
                setListProdutos([]);

                searchFromCHB(
                    [
                        {key: 'codigo', value: inputSearchProduto || 0},
                        {key: 'descricao', value: inputDescricaoSearchProduto},
                    ], empresa.id, 'produtos'
                ).then(result => {
                    if(result.affectedRows) {
                        setListProdutos(result.result);
                    }
                }).finally(() => {
                    setSearching(false);
                });
            }
        }
    }

    function changeHeight(element) {
        element.style.height = `20.8px`;
        element.style.height = `${element.scrollHeight+1.8}px`;
    }

    function changeInputValue(element, len, mask) {
        let newValue = element.value;

        if(mask === 'number') {
            return parseInt(newValue.replace(/[^0-9]/g, '').slice(0, len));
        } else if(mask === 'number_as_string') {
            return newValue.replace(/[^0-9]/g, '').slice(0, len);
        } else if(mask === 'monetary' || mask === 'quantity') {
            newValue = newValue.replace(/[^0-9]/g, '').slice(0, len);
            let decimalLen = mask === 'monetary' ? 4 : 2;
            let sliceLen = decimalLen >= newValue.length ? 0 : (newValue.length - decimalLen);

            return parseFloat(newValue.slice(0, sliceLen) + '.' + newValue.slice(sliceLen).padStart(decimalLen, '0'));
        } else if(mask === 'phone') {
            return newValue.replace(/[^0-9 ()+-]/g, '').slice(0, len);
        } else if(mask === 'ie') {
            return newValue.replace(/[^0-9-/.]/g, '').slice(0, len);
        } else if(mask === 'cfop') {
            return newValue.replace(/[^0-9.]/g, '').slice(0, len);
        } else if(mask === 'placa') {
            newValue = newValue.toUpperCase().replace(/[^0-9A-Z]/g, '');

            const regex = (/^([A-Z]{3})(\d{2,4})/).test(newValue) ? /^([A-Z]{3})(\d{1,4})/ : /^([0-9A-Z])/;
            const regexText = (/^([A-Z]{3})(\d{2,4})/).test(newValue) ? '$1-$2' : '$1';

            return newValue.replace(regex, regexText).slice(0, (/^([A-Z]{3})(\d{2,4})/).test(newValue) ? len : (len - 1));
        } else if(mask === 'cpf') {
            newValue = newValue.replace(/[^0-9]/g, '');

            const regex = (newValue.length < 7) ? /^(\d{3})(\d{1,3})/ : (newValue.length < 10) ? /^(\d{3})(\d{3})(\d{1,3})/ : /^(\d{3})(\d{3})(\d{3})(\d{1,2})/;
            const regexText = (newValue.length < 7) ? '$1.$2' : (newValue.length < 10) ? '$1.$2.$3' : '$1.$2.$3-$4';

            return newValue.replace(regex, regexText).slice(0, len);
        } else if(mask === 'cnpj_cpf') {
            newValue = newValue.replace(/[^0-9]/g, '');

            const regex = (newValue.length < 11) ? /^(\d)/ : (newValue.length < 12) ? /^(\d{3})(\d{3})(\d{3})(\d{2})/ : (newValue.length < 13) ? /^(\d{2})(\d{3})(\d{3})(\d{4})/ : /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/;
            const regexText = (newValue.length < 11) ? '$1' : (newValue.length < 12) ? '$1.$2.$3-$4' : (newValue.length < 13) ? '$1.$2.$3/$4' : '$1.$2.$3/$4-$5';

            return newValue.replace(regex, regexText).slice(0, len);
        } else if(mask === 'data') {
            newValue = newValue.replace(/[^0-9]/g, '');

            const regex = (newValue.length < 5) ? /^(\d{2})(\d{1,2})/ : /^(\d{2})(\d{2})(\d{1,4})/;
            const regexText = (newValue.length < 5) ? '$1/$2' : '$1/$2/$3';

            return newValue.replace(regex, regexText).slice(0, len);
        } else if(mask === 'upper') {
            newValue = newValue.toUpperCase();
        }

        return newValue.replace('\n', '').slice(0, len);
    }

    function changeSelectValue(obj, value) {
        let newObj = Object.assign([], obj);

        newObj.selectItem = value;

        return newObj;
    }

    function removeAlertErro(id, element) {
        if(id) {
            document.getElementById(id).classList.remove(
                stylesprintformulario.carderro, stylesprintformulario.columnbodycarderror, stylesprintformulario.columnbodycarderrorobr,
                stylesprintformulario.columnbodycarderroremail, stylesprintformulario.columnbodycarderrorcpf, stylesprintformulario.columnbodycarderrorplaca
            );
        } else {
            element.classList.remove(
                stylesprintformulario.carderro, stylesprintformulario.columnbodycarderror, stylesprintformulario.columnbodycarderrorobr,
                stylesprintformulario.columnbodycarderroremail, stylesprintformulario.columnbodycarderrorcpf, stylesprintformulario.columnbodycarderrorplaca
            );
        }
    }

    function renderCardBeforeSearch(object, searching, childObject, onlyLoad, ignoreSupCard) {
        if(ignoreSupCard) {
            return
        } else if(searching) {
            return (
                <div className={stylesprintformulario.cardbeforesearch}>
                    <div className={loadingstyles.ldsellipsis}><div></div><div></div><div></div><div></div></div>
                </div>
            )
        } else if(!Object.keys(object).length && !childObject && !onlyLoad) {
            return (
                <div className={stylesprintformulario.cardbeforesearch}>INFORME O CÓDIGO PARA PROSSEGUIR...</div>
            )
        } else if(Object.keys(object).length && childObject && !childObject.length && !onlyLoad && capaFormulario.status === 0) {
            return (
                <div className={stylesprintformulario.cardbeforesearch}>NÃO EXISTEM SERVIÇOS LANÇADOS PARA O DOCUMENTO SELECIONADO!</div>
            )
        } else if(!Object.keys(object).length && childObject && !childObject.length && !onlyLoad) {
            return (
                <div className={stylesprintformulario.cardbeforesearch}></div>
            )
        }
    }

    function setInputProduto(value, property, index) {
        let newObj = Object.assign([], selectedProdutos);

        newObj[index][property] = value;

        setSelectedProdutos(newObj);
    }

    function handleAddSelectedProduto(produto) {
        let newObj = Object.assign([], selectedProdutos);

        newObj.push({
            codigo: produto.codigo,
            descricao: produto.descricao,
            unidade_medida: produto.unidade_medida,
            peso: produto.peso,
            cfop: produto.cfop,
            quantidade: produto.quantidade,
            valor_unitario: produto.valor_unitario,
        });

        setSelectedProdutos(newObj);
    }

    function handleRemoveProduto(index) {
        let newObj = Object.assign([], selectedProdutos);

        if(newObj[index].id) {
            newObj[index].deleted = true;
        } else {
            newObj.splice(index, 1);
        }

        setSelectedProdutos(newObj);
    }

    function handleRemoveProdutoAlert(e) {
        if(e.type === 'mouseenter') {
            e.currentTarget.parentElement.parentElement.classList.add(stylesprintformulario.alertremoveproduto);
        } else {
            e.currentTarget.parentElement.parentElement.classList.remove(stylesprintformulario.alertremoveproduto);
        }
    }

    function handleImprimir() {
        if(!searching && !searchingFornecedor && !searchingOrdemServ && !searchingProduto && !searchingTransportador) {
            setPrinting(true);

            let hasErro = false;
            const blocos = [
                {id: 'empresa', value: empresa.id, ativo: true, inputs: [
                    {id: 'inputEmail', value: inputEmail, type: 'email', required: true}, {id: 'inputTelefone', value: inputTelefone, required: true},
                    {id: 'inputEndereco', value: inputEndereco, required: true}
                ]},
                {id: 'fornecedor', value: fornecedor.codigo, ativo: true, inputs: [
                    {id: 'inputIEFornecedor', value: inputIEFornecedor, required: true}, {id: 'inputEmailFornecedor', value: inputEmailFornecedor, type: 'email', required: true},
                    {id: 'inputTelefoneFornecedor', value: inputTelefoneFornecedor, required: true}, {id: 'inputEnderecoFornecedor', value: inputEnderecoFornecedor, required: true}
                ]},
                {id: 'ordemServ', value: ordemServ.codigo, ativo: [0].includes(capaFormulario.tipo)},
                {id: 'selectedProdutos', value: selectedProdutos.filter(produto => !produto.deleted).length, ativo: true, inputs:
                    selectedProdutos.flatMap((produto, index) => {
                        if(!produto.deleted) {
                            return [
                                // REQUIRED SÓ É TRUE EM ALGUNS TIPOS DE FORMULÁRIO (sempre lembrar de cadastrar)
                                {id: `inputProdutoPeso${index}`, value: produto.peso, required: [].includes(capaFormulario.tipo) ? true : false},
                                {id: `inputProdutoCfop${index}`, value: produto.cfop, required: [].includes(capaFormulario.tipo) ? true : false},
                                {id: `inputProdutoQuantidade${index}`, value: produto.quantidade, required: [].includes(capaFormulario.tipo) ? true : false},
                                {id: `inputProdutoValorUnit${index}`, value: produto.valor_unitario, required: [].includes(capaFormulario.tipo) ? true : false}
                            ]
                        }
                    }).filter(produto => produto)
                },
                {id: 'transportador', value: transportador.codigo, ativo: (selectTipoFrete.selectItem === 2 ? true : false), inputs: [
                    {id: 'inputCidadeUfTransportador', value: inputCidadeUfTransportador, required: true}, {id: 'inputTelefoneTransportador', value: inputTelefoneTransportador, required: true},
                    {id: 'inputVeiculoTransportador', value: inputVeiculoTransportador, required: true}, {id: 'inputPlacaTransportador', value: inputPlacaTransportador, type: 'placa', required: true},
                    {id: 'inputNomeResponsavelFrete', value: inputNomeResponsavelFrete, required: true}
                ]},
                {
                    id: null, value: true, ativo: (selectTipoFrete.selectItem === 1 || (selectTipoFrete.selectItem === 2 && transportador.codigo) ? true : false), inputs: [
                        {id: 'inputNomeMotoristaTransportador', value: inputNomeMotoristaTransportador, required: true},
                        {id: 'inputCpfMotoristaTransportador', value: inputCpfMotoristaTransportador, type: 'cpf', required: true},
                        {id: 'inputTelefoneMotoristaTransportador', value: inputTelefoneMotoristaTransportador, required: true}
                    ]
                }
            ];

            blocos.forEach(bloco => {
                if(!bloco.value && bloco.ativo) {
                    document.getElementById(bloco.id).classList.add(stylesprintformulario.carderro);
                    hasErro = true;
                } else if(bloco.inputs && bloco.ativo) {
                    bloco.inputs.forEach(input => {
                        if(input.required && !input.value) {
                            document.getElementById(input.id).classList.add(stylesprintformulario.columnbodycarderror, stylesprintformulario.columnbodycarderrorobr);
                            hasErro = true;
                        } else if(input.required && input.type === 'email' && !(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi).test(input.value)) {
                            document.getElementById(input.id).classList.add(stylesprintformulario.columnbodycarderror, stylesprintformulario.columnbodycarderroremail);
                            hasErro = true;
                        } else if(input.required && input.type === 'cpf' && !(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/).test(input.value)) {
                            document.getElementById(input.id).classList.add(stylesprintformulario.columnbodycarderror, stylesprintformulario.columnbodycarderrorcpf);
                            hasErro = true;
                        } else if(input.required && input.type === 'placa' && !((/^([A-Z]{3})-(\d{4})/).test(input.value) || (/^([A-Z]{3})(\d{1})([A-Z]{1})(\d{2})/).test(input.value))) {
                            document.getElementById(input.id).classList.add(stylesprintformulario.columnbodycarderror, stylesprintformulario.columnbodycarderrorplaca);
                            hasErro = true;
                        }
                    });
                }
            });

            if(hasErro) {
                setPrinting(false);

                Swal.fire({
                    customClass: {
                        container: swalstyles.swaltoastconteiner,
                        popup: swalstyles.swaltoastpopup,
                        htmlContainer: swalstyles.swaltoasttext,
                        icon: swalstyles.swaltoasticon,
                        timerProgressBar: swalstyles.swaltoastprogressbar,
                    },
                    position: 'top-right',
                    toast: true,
                    text: 'PREENCHA CORRETAMENTE TODOS OS DADOS ANTES DE FINALIZAR.',
                    timer: 5000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    icon: 'info',
                });
            } else {
                const body = {
                    htmlStyle: stylesprintformulario,
                    htmlBody: document.getElementById('printFormulario').outerHTML,
                    // ESTRUTURA PARA INSERIR NAS TABELAS
                    isUpdate: history.location.state.id_formulario_os_capa ? true : false,
                    formulario_os_capa: {
                        id: capaFormulario.id,
                        email_empresa: inputEmail,
                        telefone_empresa: inputTelefone,
                        endereco_empresa: inputEndereco,
                        codigo_destinatario: fornecedor.codigo,
                        descricao_destinatario: fornecedor.descricao,
                        cnpj_destinatario: fornecedor.cnpj,
                        inscricao_estadual_destinatario: inputIEFornecedor,
                        email_destinatario: inputEmailFornecedor,
                        telefone_destinatario: inputTelefoneFornecedor,
                        endereco_destinatario: inputEnderecoFornecedor,
                        codigo_os: ordemServ.codigo,
                        data_abertura_os: ordemServ.data_abertura,
                        centro_custo_os: ordemServ.centro_custo,
                        solicitante_os: ordemServ.solicitante,
                        codigo_frota_os: ordemServ.frota.codigo,
                        descricao_frota_os: ordemServ.frota.descricao,
                        placa_frota_os: ordemServ.frota.placa,
                        chassi_frota_os: ordemServ.frota.chassi,
                        proprietario_frota_os: ordemServ.frota.proprietario,
                        uf_placa_frota_os: ordemServ.frota.uf_placa,
                        observacao_os: inputObservacaoOs,
                        codigo_transportador: transportador.codigo,
                        descricao_transportador: transportador.descricao,
                        cnpj_transportador: transportador.cnpj,
                        cidade_uf_transportador: inputCidadeUfTransportador,
                        telefone_transportador: inputTelefoneTransportador,
                        veiculo_transportador: inputVeiculoTransportador,
                        placa_transportador: inputPlacaTransportador,
                        nome_motorista_transportador: inputNomeMotoristaTransportador,
                        cpf_motorista_transportador: removeMask(inputCpfMotoristaTransportador),
                        telefone_motorista_transportador: inputTelefoneMotoristaTransportador,
                        tipo_frete: selectTipoFrete.selectItem,
                        responsavel_frete: selectResponsavelFrete.selectItem,
                        nome_responsavel_frete: inputNomeResponsavelFrete,
                    },
                    insert_formulario_os_produtos: selectedProdutos.filter(produto => !produto.deleted && !produto.id).map(produto => {
                        return {
                            id_formulario_os_capa: capaFormulario.id,
                            codigo: produto.codigo,
                            descricao: produto.descricao,
                            peso: produto.peso,
                            unidade_medida: produto.unidade_medida,
                            cfop: produto.cfop,
                            quantidade: produto.quantidade,
                            valor_unitario: produto.valor_unitario,
                        }
                    }),
                    update_formulario_os_produtos: selectedProdutos.filter(produto => !produto.deleted && produto.id).map(produto => {
                        return {
                            id: produto.id,
                            peso: produto.peso,
                            cfop: produto.cfop,
                            quantidade: produto.quantidade,
                            valor_unitario: produto.valor_unitario,
                        }
                    }),
                    delete_formulario_os_produtos: selectedProdutos.filter(produto => produto.deleted && produto.id).map(produto => {
                        return { id: produto.id }
                    }),
                }

                api.post(`/formulario/salvarformulario`, body, {responseType: 'blob'}).then(response => {
                    if(response.data && !response.data.error) {
                        fileDownload(response.data, `formulario_orcamento_doc_${capaFormulario.id.toString().padStart(6, '0')}.pdf`);
                        handleAfterPrint(capaFormulario.id);
                    } else {
                        console.log(response.data.error);
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'NÃO FOI POSSÍVEL CONCLUIR O DOWNLOAD!',
                            text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                            icon: 'error',
                        });
                    }
                }).catch(err => {
                    // handle error
                    console.log(err);
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'NÃO FOI POSSÍVEL CONCLUIR O DOWNLOAD!',
                        text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                }).finally(() => {
                    setPrinting(false);
                });
            }
        }
    }

    function renderButtonImprimir() {
        return (
            <button className={stylesformulario.buttonimprimir} onClick={() => handleImprimir()}
                disabled={searching || searchingFornecedor || searchingOrdemServ || searchingProduto || searchingTransportador}
            >
                IMPRIMIR
            </button>
        )
    }

    function closeModalSearch(selectedData) {
        if(modalSearchFornecedor) {
            setInputSearchFornecedor(null);
            setInputDescricaoSearchFornecedor('');
            setInputCnpjSearchFornecedor('');
            setListFornecedor([]);

            setModalSearchFornecedor(false);

            if(selectedData) {
                removeAlertErro('inputIEFornecedor');
                removeAlertErro('inputEmailFornecedor');
                removeAlertErro('inputTelefoneFornecedor');
                removeAlertErro('inputEnderecoFornecedor');

                setFornecedor({
                    codigo: selectedData.codigo,
                    descricao: selectedData.descricao,
                    cnpj: selectedData.cnpj,
                });

                setInputIEFornecedor(selectedData.inscricao_estadual || '');
                setInputEmailFornecedor(selectedData.email || '');
                setInputTelefoneFornecedor(selectedData.telefone || '');
                setInputEnderecoFornecedor(`${selectedData.logradouro ? selectedData.logradouro : ''}${selectedData.logradouro && ((selectedData.cidade && selectedData.uf) || selectedData.cep) ? '; ' : ''}${selectedData.cidade && selectedData.uf ? `${selectedData.cidade}-${selectedData.uf}` : ''}${selectedData.cidade && selectedData.uf && selectedData.cep ? ', ' : ''}${selectedData.cep ? `CEP: ${selectedData.cep}` : ''}`);
            }
        } if(modalSearchTransportador) {
            setInputSearchTransportador(null);
            setInputDescricaoSearchTransportador('');
            setInputCnpjSearchTransportador('');
            setListTransportador([]);

            setModalSearchTransportador(false);

            if(selectedData) {
                removeAlertErro('inputCidadeUfTransportador');
                removeAlertErro('inputTelefoneTransportador');
                removeAlertErro('inputVeiculoTransportador');
                removeAlertErro('inputPlacaTransportador');

                setTransportador({
                    codigo: selectedData.codigo,
                    descricao: selectedData.descricao,
                    cnpj: selectedData.cnpj,
                });
                setInputCidadeUfTransportador(selectedData.cidade && selectedData.uf ? `${selectedData.cidade}-${selectedData.uf}` : '');
                setInputTelefoneTransportador(selectedData.telefone || '');
                setInputVeiculoTransportador('');
                setInputPlacaTransportador('');
                setInputNomeMotoristaTransportador('');
                setInputCpfMotoristaTransportador('');
                setInputTelefoneMotoristaTransportador('');
            }
        } else if(modalSearchOrdemServ) {
            setInputSearchOrdemServ(null);
            setInputFrotaSearchOrdemServ('');
            setInputDataInicialSearchOrdemServ('');
            setInputDataFinalSearchOrdemServ('');
            setListOrdemServ([]);
            
            setModalSearchOrdemServ(false);
            
            if(selectedData) {
                removeAlertErro('selectedProdutos');
                removeAlertErro('inputUfFrotaOrdemServ');

                setSelectedProdutos([]);

                setOrdemServ({
                    codigo: selectedData.codigo,
                    data_abertura: moment(selectedData.data_abertura, 'YYYY MM DDTHH mm ss').format('YYYY-MM-DD'),
                    centro_custo: selectedData.centro_custo,
                    solicitante: selectedData.solicitante,
                    frota: {
                        codigo: selectedData.frota_codigo,
                        descricao: selectedData.frota_descricao,
                        placa: selectedData.frota_placa,
                        chassi: selectedData.frota_chassi,
                        proprietario: selectedData.frota_proprietario,
                        uf_placa: selectedData.uf_placa,
                    },
                });

                setInputObservacaoOs('');

                setProdutos(
                    selectedData.produtos.map(produto => {
                        return ({
                            codigo: produto.codigo,
                            descricao: produto.descricao,
                            unidade_medida: produto.unidade_medida,
                            peso: null,
                            cfop: null,
                            quantidade: produto.quantidade,
                            valor_unitario: produto.valor_unitario,
                        })
                    })
                );
            }
        } else if(modalSearchProduto) {
            setInputSearchProduto(null);
            setInputDescricaoSearchProduto('');
            setListProdutos([]);

            setModalSearchProduto(false);

            if(selectedData) {
                let newObj = Object.assign([], selectedProdutos);

                newObj.push({
                    codigo: selectedData.codigo,
                    descricao: selectedData.descricao,
                    unidade_medida: selectedData.unidade_medida,
                    peso: null,
                    cfop: null,
                    quantidade: 0,
                    valor_unitario: 0,
                });

                setSelectedProdutos(newObj);
            }
        }
    }

    function changeDataInicialFilter() {
        if(!moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').isValid() && moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY').isValid()) {
            setInputDataInicialSearchOrdemServ(moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY').subtract(3, 'month').format('DD/MM/YYYY'));
        }
    }

    function completeDataInicialFilter() {
        if(inputDataInicialSearchOrdemServ.length < 10 && moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').isValid()) {
            setInputDataInicialSearchOrdemServ(moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function changeDataFinalFilter() {
        if(!moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY').isValid() && moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').isValid()) {
            const newData = moment(inputDataInicialSearchOrdemServ, 'DD MM YYYY').add(3, 'month');

            if(newData.isAfter(moment())) {
                setInputDataFinalSearchOrdemServ(moment().format('DD/MM/YYYY'));
            } else {
                setInputDataFinalSearchOrdemServ(newData.format('DD/MM/YYYY'));
            }
        }
    }

    function completeDataFinalFilter() {
        if(inputDataFinalSearchOrdemServ.length < 10 && moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY').isValid()) {
            setInputDataFinalSearchOrdemServ(moment(inputDataFinalSearchOrdemServ, 'DD MM YYYY').format('DD/MM/YYYY'));
        }
    }

    function renderInputModalSearch() {
        if(modalSearchFornecedor) {
            return (
                <div className={stylesformulario.conteinermodalfilter}>
                    <div className={stylesformulario.conteinermodalfilterinputs}>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_30_35].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Código do Fornecedor' autoComplete='off'
                                value={inputSearchFornecedor || ''} onChange={e => setInputSearchFornecedor(changeInputValue(e.target, 15, 'number'))}
                            />
                            <input className={stylesformulario.inputfilter} placeholder='CPF/CNPJ do Fornecedor' autoComplete='off'
                                value={inputCnpjSearchFornecedor || ''} onChange={e => setInputCnpjSearchFornecedor(changeInputValue(e.target, 18, 'cnpj_cpf'))}
                            />
                        </div>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_auto_20].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Descrição do Fornecedor' autoComplete='off'
                                value={inputDescricaoSearchFornecedor || ''} onChange={e => setInputDescricaoSearchFornecedor(changeInputValue(e.target, 50, 'upper'))}
                            />
                        </div>
                    </div>
                    <input type='button' className={stylesformulario.buttonfilter} value='Filtrar' onClick={() => searchListFornecedor()}
                        disabled={(!inputSearchFornecedor && !inputDescricaoSearchFornecedor && !inputCnpjSearchFornecedor) || searching}
                    />
                </div>
            )
        } else if(modalSearchTransportador) {
            return (
                <div className={stylesformulario.conteinermodalfilter}>
                    <div className={stylesformulario.conteinermodalfilterinputs}>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_30_35].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Código do Fornecedor' autoComplete='off'
                                value={inputSearchTransportador || ''} onChange={e => setInputSearchTransportador(changeInputValue(e.target, 15, 'number'))}
                            />
                            <input className={stylesformulario.inputfilter} placeholder='CPF/CNPJ do Fornecedor' autoComplete='off'
                                value={inputCnpjSearchTransportador || ''} onChange={e => setInputCnpjSearchTransportador(changeInputValue(e.target, 18, 'cnpj_cpf'))}
                            />
                        </div>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_auto_20].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Descrição do Fornecedor' autoComplete='off'
                                value={inputDescricaoSearchTransportador || ''} onChange={e => setInputDescricaoSearchTransportador(changeInputValue(e.target, 50, 'upper'))}
                            />
                        </div>
                    </div>
                    <input type='button' className={stylesformulario.buttonfilter} value='Filtrar' onClick={() => searchListTransportador()}
                        disabled={(!inputSearchTransportador && !inputDescricaoSearchTransportador && !inputCnpjSearchTransportador) || searching}
                    />
                </div>
            )
        } else if(modalSearchOrdemServ) {
            return (
                <div className={stylesformulario.conteinermodalfilter}>
                    <div className={stylesformulario.conteinermodalfilterinputs}>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_30_auto_auto].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Código da OS' autoComplete='off'
                                value={inputSearchOrdemServ || ''} onChange={e => setInputSearchOrdemServ(changeInputValue(e.target, 15, 'number'))}
                            />
                            <input className={stylesformulario.inputfilter} placeholder='Data Inicial' autoComplete='off'
                                onFocus={() => changeDataInicialFilter()} onBlur={() => completeDataInicialFilter()}
                                value={inputDataInicialSearchOrdemServ || ''} onChange={e => setInputDataInicialSearchOrdemServ(changeInputValue(e.target, 10, 'data'))}
                            />
                            <input className={stylesformulario.inputfilter} placeholder='Data Final' autoComplete='off'
                                onFocus={() => changeDataFinalFilter()} onBlur={() => completeDataFinalFilter()}
                                value={inputDataFinalSearchOrdemServ || ''} onChange={e => setInputDataFinalSearchOrdemServ(changeInputValue(e.target, 10, 'data'))}
                            />
                        </div>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_30_auto].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Código da Frota' autoComplete='off'
                                value={inputFrotaSearchOrdemServ || ''} onChange={e => setInputFrotaSearchOrdemServ(changeInputValue(e.target, 5, 'number_as_string'))}
                            />
                            <div className={stylesformulario.alertfilter}>
                                Faixa de pesquisa por data é limitada em 3 meses!
                            </div>
                        </div>
                    </div>
                    <input type='button' className={stylesformulario.buttonfilter} value='Filtrar' onClick={() => searchListOrdemServ()}
                        disabled={(!inputSearchOrdemServ && !inputDataInicialSearchOrdemServ && !inputDataFinalSearchOrdemServ && !inputFrotaSearchOrdemServ) || searching}
                    />
                </div>
            )
        } else if(modalSearchProduto) {
            return (
                <div className={stylesformulario.conteinermodalfilter}>
                    <div className={stylesformulario.conteinermodalfilterinputs}>
                        <div className={[stylesformulario.filterline, stylesformulario.filterline_30_auto].join(' ')}>
                            <input className={stylesformulario.inputfilter} placeholder='Código do Produto' autoComplete='off'
                                value={inputSearchProduto || ''} onChange={e => setInputSearchProduto(changeInputValue(e.target, 15, 'number'))}
                            />
                            <input className={stylesformulario.inputfilter} placeholder='Descrição do Produto' autoComplete='off'
                                value={inputDescricaoSearchProduto || ''} onChange={e => setInputDescricaoSearchProduto(changeInputValue(e.target, 50, 'upper'))}
                            />
                        </div>
                    </div>
                    <input type='button' className={stylesformulario.buttonfilter} value='Filtrar' onClick={() => searchListProduto()}
                        disabled={(!inputSearchProduto && !inputDescricaoSearchProduto) || searching}
                    />
                </div>
            )
        }
    }

    function renderBodyListModalSearch() {
        if(searching) {
            return (
                <div className={stylesformulario.conteineremptylist}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        } else if(modalSearchFornecedor) {
            if(!listFornecedor.length) {
                return (
                    <div className={stylesformulario.conteineremptylist}>
                        Nenhum registro encontrado.
                    </div>
                )
            } else {
                return (
                    listFornecedor.map((fornecedor, index) => {
                        return (
                            <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerbodylist, stylesformulario.conteinerlist_10_70_20].join(' ')} key={index}
                                onClick={() => closeModalSearch(fornecedor)}
                            >
                                <div>{fornecedor.codigo}</div>
                                <div>{fornecedor.descricao}</div>
                                <div>{maskCpfCnpj(fornecedor.cnpj)}</div>
                            </div>
                        )
                    })
                )
            }
        } else if(modalSearchTransportador) {
            if(!listTransportador.length) {
                return (
                    <div className={stylesformulario.conteineremptylist}>
                        Nenhum registro encontrado.
                    </div>
                )
            } else {
                return (
                    listTransportador.map((fornecedor, index) => {
                        return (
                            <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerbodylist, stylesformulario.conteinerlist_10_70_20].join(' ')} key={index}
                                onClick={() => closeModalSearch(fornecedor)}
                            >
                                <div>{fornecedor.codigo}</div>
                                <div>{fornecedor.descricao}</div>
                                <div>{maskCpfCnpj(fornecedor.cnpj)}</div>
                            </div>
                        )
                    })
                )
            }
        } else if(modalSearchOrdemServ) {
            if(!listOrdemServ.length) {
                return (
                    <div className={stylesformulario.conteineremptylist}>
                        Nenhum registro encontrado.
                    </div>
                )
            } else {
                return (
                    listOrdemServ.map((ordemServ, index) => {
                        return (
                            <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerbodylist, stylesformulario.conteinerlist_10_5_65_20].join(' ')} key={index}
                                onClick={() => closeModalSearch(ordemServ)}
                            >
                                <div>{ordemServ.codigo}</div>
                                <div>{ordemServ.frota_codigo}</div>
                                <div>{ordemServ.frota_descricao}</div>
                                <div>{moment(ordemServ.data_abertura, 'YYYY MM DDTHH mm ss').format('DD/MM/YYYY')}</div>
                            </div>
                        )
                    })
                )
            }
        } else if(modalSearchProduto) {
            if(!listProdutos.length) {
                return (
                    <div className={stylesformulario.conteineremptylist}>
                        Nenhum registro encontrado.
                    </div>
                )
            } else {
                return (
                    listProdutos.map((produto, index) => {
                        return (
                            <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerbodylist, stylesformulario.conteinerlist_10_70_20].join(' ')} key={index}
                                onClick={() => closeModalSearch(produto)}
                            >
                                <div>{produto.codigo}</div>
                                <div>{produto.descricao}</div>
                                <div>{produto.unidade_medida}</div>
                            </div>
                        )
                    })
                )
            }
        }
    }

    function renderBodyModalSearch() {
        if(modalSearchFornecedor) {
            return (
                <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerheadlist, stylesformulario.conteinerlist_10_70_20].join(' ')}>
                    <div>Código</div>
                    <div>Descrição</div>
                    <div>CPF/CNPJ</div>
                </div>
            )
        } else if(modalSearchTransportador) {
            return (
                <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerheadlist, stylesformulario.conteinerlist_10_70_20].join(' ')}>
                    <div>Código</div>
                    <div>Descrição</div>
                    <div>CPF/CNPJ</div>
                </div>
            )
        } else if(modalSearchOrdemServ) {
            return (
                <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerheadlist, stylesformulario.conteinerlist_10_5_65_20].join(' ')}>
                    <div>Código</div>
                    <div>Frota</div>
                    <div>Descrição Frota</div>
                    <div>Data Abertura</div>
                </div>
            )
        } else if(modalSearchProduto) {
            return (
                <div className={[stylesformulario.conteinerlist, stylesformulario.conteinerheadlist, stylesformulario.conteinerlist_10_70_20].join(' ')}>
                    <div>Código</div>
                    <div>Descrição</div>
                    <div>Unid. de Medida</div>
                </div>
            )
        }
    }

    function renderModalSearch() {
        if(modalSearchFornecedor || modalSearchOrdemServ || modalSearchProduto || modalSearchTransportador) {
            return (
                <div className={[swalstyles.conteiner, swalstyles.conteinerminwidth500px].join(' ')}>
                    <div className={[swalstyles.modal, swalstyles.modallargerwidth, swalstyles.modalmaxheight3rows].join(' ')}>
                        {renderInputModalSearch()}
                        <div className={[swalstyles.conteinerbody, swalstyles.conteinerbodymaxheight].join(' ')}>
                            {renderBodyModalSearch()}
                            {renderBodyListModalSearch()}
                        </div>
                        <div className={swalstyles.conteinerbuttons}>
                            <input type='button' className={[swalstyles.buttons, swalstyles.cancelbutton].join(' ')}
                                value='Fechar' onClick={() => closeModalSearch()}
                            />
                        </div>
                    </div>
                </div>
            )
        }
    }

    function renderTitleTipoOs() {
        switch (capaFormulario.tipo) {
            case 0:
                return 'SOLICITAÇÃO DE ORÇAMENTO - SERVIÇOS TERCEIROS'
            case 1:
                return 'SOLICITAÇÃO DE ORÇAMENTO - RECAPAGEM PNEUS'
            // case 2:
            //         return 'REQUERIMENTO NOTA FISCAL - REMESSA'
            default:
                return '';
        }
    }

    function renderCardEmpresa() {
        return (
            <div className={[stylesprintformulario.card, 'card_F0rm102023'].join(' ')} id='empresa'>
                <div className={[stylesprintformulario.titlecard, 'titlecard_F0rm102023'].join(' ')}>
                    DADOS DO REMETENTE:
                </div>
                <div className={[stylesprintformulario.bodycard, 'bodycard_F0rm102023'].join(' ')}>
                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_30_20].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>EMPRESA:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={empresa.razao_social || ''} readOnly={true}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>CNPJ/CPF:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                value={empresa.cnpj || ''} readOnly={true}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>I.E:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')}
                                value={empresa.inscricao_estadual || ''} readOnly={true}
                            />
                        </div>
                    </div>

                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_50].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard} id='inputEmail'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>EMAIL:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputEmail} onChange={e => setInputEmail(changeInputValue(e.target, 50))} onFocus={e => removeAlertErro('inputEmail')}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard} id='inputTelefone'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>TELEFONE:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                value={inputTelefone} onChange={e => setInputTelefone(changeInputValue(e.target, 20, 'phone'))} onFocus={e => removeAlertErro('inputTelefone')}
                            />
                        </div>
                    </div>
                    
                    <div className={stylesprintformulario.linebodycard}>
                        <div className={stylesprintformulario.columnbodycard} id='inputEndereco'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>ENDEREÇO:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputEndereco} onChange={e => setInputEndereco(changeInputValue(e.target, 130))} onFocus={e => removeAlertErro('inputEndereco')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function renderInputSearchFornecedor() {
        if(!capaFormulario.status || editarFornecedor) {
            return (
                <label className={[stylesprintformulario.searchcard, 'searchcard_F0rm102023'].join(' ')} htmlFor='inputsearchfornecedor' onFocus={e => removeAlertErro('fornecedor')}>
                    <input id='inputsearchfornecedor' className={stylesprintformulario.searchcardinput} placeholder='Pesquisar código' autoComplete='off'
                        value={inputSearchFornecedor || ''} onChange={e => setInputSearchFornecedor(changeInputValue(e.target, 15, 'number'))}
                        onKeyDown={(e) => {if(e.key === 'Enter') {searchFornecedorByCodigo()}}} title="Pressione 'Enter' para pesquisar"
                    />
                    <BsSearch className={stylesprintformulario.searchcardicon} onClick={() => setModalSearchFornecedor(true)} /> 
                </label>
            )
        } else {
            return (
                <button className='searchcard_F0rm102023' onClick={() => setEditarFornecedor(true)} style={{ border: '1px solid', borderRadius: '10px', fontSize: '9px', margin: '-3px' }} disabled={searching || loading || printing}>
                    Alterar Fornecedor
                </button>
            )
        }
    }

    function renderCardFornecedor() {
        return (
            <div className={[stylesprintformulario.card, 'card_F0rm102023'].join(' ')} id='fornecedor'>
                {renderCardBeforeSearch(fornecedor, searchingFornecedor)}
                <div className={[stylesprintformulario.titlecard, 'titlecard_F0rm102023'].join(' ')}>
                    DADOS DO DESTINATÁRIO:
                    {renderInputSearchFornecedor()}
                </div>
                <div className={[stylesprintformulario.bodycard, 'bodycard_F0rm102023'].join(' ')}>
                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_30_20].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>FORNECEDOR:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={fornecedor.codigo ? `${fornecedor.codigo} - ${fornecedor.descricao}` : ''} readOnly={true}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>CNPJ/CPF:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                value={maskCpfCnpj(fornecedor.cnpj || '')} readOnly={true}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard} id='inputIEFornecedor'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>I.E:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                value={inputIEFornecedor} onChange={e => setInputIEFornecedor(changeInputValue(e.target, 20, 'ie'))} onFocus={e => removeAlertErro('inputIEFornecedor')}
                            />
                        </div>
                    </div>

                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_50].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard} id='inputEmailFornecedor'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>EMAIL:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputEmailFornecedor} onChange={e => setInputEmailFornecedor(changeInputValue(e.target, 50))} onFocus={e => removeAlertErro('inputEmailFornecedor')}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard} id='inputTelefoneFornecedor'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>TELEFONE:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                value={inputTelefoneFornecedor} onChange={e => setInputTelefoneFornecedor(changeInputValue(e.target, 20, 'phone'))} onFocus={e => removeAlertErro('inputTelefoneFornecedor')}
                            />
                        </div>
                    </div>
                    
                    <div className={stylesprintformulario.linebodycard}>
                        <div className={stylesprintformulario.columnbodycard} id='inputEnderecoFornecedor'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>ENDEREÇO:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputEnderecoFornecedor} onChange={e => setInputEnderecoFornecedor(changeInputValue(e.target, 130))} onFocus={e => removeAlertErro('inputEnderecoFornecedor')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function renderInputSearchOrdemServ() {
        if(!capaFormulario.status) {
            return (
                <label className={[stylesprintformulario.searchcard, 'searchcard_F0rm102023'].join(' ')} htmlFor='inputsearchordemserv' onFocus={e => removeAlertErro('ordemServ')}>
                    <input id='inputsearchordemserv' className={stylesprintformulario.searchcardinput} placeholder='Pesquisar código' autoComplete='off'
                        value={inputSearchOrdemServ || ''} onChange={e => setInputSearchOrdemServ(changeInputValue(e.target, 15, 'number'))}
                        onKeyDown={(e) => {if(e.key === 'Enter') {searchOrdemServByCodigo()}}} title="Pressione 'Enter' para pesquisar"
                    />
                    <BsSearch className={stylesprintformulario.searchcardicon} onClick={() => setModalSearchOrdemServ(true)} /> 
                </label>
            )
        }
    }

    function renderCardOrdemServ() {
        // 0 - SERVIÇOS TERCEIROS
        if([0].includes(capaFormulario.tipo)) {
            return (
                <div className={[stylesprintformulario.card, 'card_F0rm102023'].join(' ')} id='ordemServ'>
                    {renderCardBeforeSearch(ordemServ, searchingOrdemServ)}
                    <div className={[stylesprintformulario.titlecard, 'titlecard_F0rm102023'].join(' ')}>
                        DADOS DA ORDEM DE SERVIÇO:
                        {renderInputSearchOrdemServ()}
                    </div>
                    <div className={[stylesprintformulario.bodycard, 'bodycard_F0rm102023'].join(' ')}>
                        <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_30_20_20_30].join(' ')}>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>NÚMERO O.S:</div>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                    value={ordemServ.codigo || ''} readOnly={true}
                                />
                            </div>
                            <div></div>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>DATA:</div>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                    value={ordemServ.data_abertura ? moment(ordemServ.data_abertura, 'YYYY MM DD').format('DD/MM/YYYY') : ''} readOnly={true}
                                />
                            </div>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>CENTRO CUSTO:</div>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                    value={ordemServ.centro_custo || ''} readOnly={true}
                                />
                            </div>
                        </div>

                        <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_20_30].join(' ')}>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>FROTA:</div>
                                <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                    value={ordemServ.frota ? `${ordemServ.frota.codigo} - ${ordemServ.frota.descricao}` : ''} readOnly={true}
                                />
                            </div>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>PLACA:</div>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                    value={ordemServ.frota ? ordemServ.frota.placa || '' : ''} readOnly={true}
                                />
                            </div>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>CHASSI:</div>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                    value={ordemServ.frota ? ordemServ.frota.chassi || '' : ''} readOnly={true}
                                />
                            </div>
                        </div>
                        
                        <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_50].join(' ')}>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>PROPRIETÁRIO:</div>
                                <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                    value={ordemServ.frota ? ordemServ.frota.proprietario || '' : ''} readOnly={true}
                                />
                            </div>
                            <div className={stylesprintformulario.columnbodycard} id='inputUfFrotaOrdemServ'>
                                <div /><span />
                                <div className={stylesprintformulario.bodycardlabel}>UF PLACA:</div>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                    value={ordemServ.frota && ordemServ.frota.placa ? ordemServ.frota.uf_placa || '' : ''} readOnly={true}
                                />
                            </div>
                        </div>

                        <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_50].join(' ')}>
                            <div className={stylesprintformulario.columnbodycard}>
                                <div className={stylesprintformulario.bodycardlabel}>SOLICITANTE:</div>
                                <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                    value={ordemServ.solicitante || ''} readOnly={true}
                                />
                            </div>
                        </div>

                        <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard].join(' ')}>
                            <div className={stylesprintformulario.columnbodycard} id='inputObservacaoOs'>
                                <div /><span />
                                <div className={stylesprintformulario.bodycardlabel}>OBSERVAÇÃO:</div>
                                <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                    value={inputObservacaoOs} onChange={e => setInputObservacaoOs(changeInputValue(e.target, 2000))}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    function renderSelectedProdutos() {
        return (
            selectedProdutos.map((produto, index) => {
                if(!produto.deleted) {
                    return (
                        <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_34_10_6_6_9_15_20_auto, 'linetableproduto_F0rm102023'].join(' ')} key={index}>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>
                                <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                    value={produto.codigo ? `${produto.codigo} - ${produto.descricao}` : ''} readOnly={true}
                                />
                            </div>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')} id={`inputProdutoPeso${index}`}>
                                <span />
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                    value={produto.peso || ''} onChange={e => setInputProduto(changeInputValue(e.target, 10), 'peso', index)} onFocus={e => removeAlertErro(`inputProdutoPeso${index}`)}
                                />
                            </div>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')}
                                    value={produto.unidade_medida || ''} readOnly={true}
                                />
                            </div>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')} id={`inputProdutoCfop${index}`}>
                                <span />
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                    value={produto.cfop || ''} onChange={e => setInputProduto(changeInputValue(e.target, 5, 'cfop'), 'cfop', index)} onFocus={e => removeAlertErro(`inputProdutoCfop${index}`)}
                                />
                            </div>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')} id={`inputProdutoQuantidade${index}`}>
                                <span />
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023', 'inputalignright_F0rm102023'].join(' ')} autoComplete='off'
                                    value={(produto.quantidade || 0).toFixed(2)} onChange={e => setInputProduto(changeInputValue(e.target, 7, 'quantity'), 'quantidade', index)} onFocus={e => removeAlertErro(`inputProdutoQuantidade${index}`)}
                                />
                            </div>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')} id={`inputProdutoValorUnit${index}`}>
                                <span />
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023', 'inputalignright_F0rm102023'].join(' ')} autoComplete='off'
                                    value={(produto.valor_unitario || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 })}
                                    onChange={e => setInputProduto(changeInputValue(e.target, 11, 'monetary'), 'valor_unitario', index)} onFocus={e => removeAlertErro(`inputProdutoValorUnit${index}`)}
                                />
                            </div>
                            <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>
                                <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023', 'inputalignright_F0rm102023'].join(' ')}
                                    value={((produto.valor_unitario || 0) * (produto.quantidade || 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 })} readOnly={true}
                                />
                            </div>
                            <div className={stylesprintformulario.conteinerremoveproduto}>
                                <BsFillXCircleFill className={[stylesprintformulario.iconremoveproduto, 'iconremoveproduto_F0rm102023'].join(' ')} onClick={() => handleRemoveProduto(index)}
                                    onMouseEnter={e => handleRemoveProdutoAlert(e)} onMouseLeave={e => handleRemoveProdutoAlert(e)}
                                />
                            </div>
                        </div>
                    )
                }
            })
        )
    }

    function renderSumValorTotalProdutos() {
        let sum = 0;

        selectedProdutos.forEach(({ quantidade, valor_unitario, deleted }) => {
            if(!deleted) {
                sum += (quantidade * valor_unitario) || 0;
            }
        });

        return sum;
    }

    function renderSelectProduto() {
        // 0 - SERVIÇOS TERCEIROS
        if([0].includes(capaFormulario.tipo)) {
            return (
                <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_44_21_15_20, 'linetableproduto_F0rm102023'].join(' ')}>
                    <div className='columntableprodutototal_F0rm102023'>
                        <Select
                            inputId='select_produto'
                            value={null}
                            options={produtos.filter(({ codigo }) => !selectedProdutos.find(selected => selected.codigo === codigo && !selected.deleted))}
                            components={{ Option }}
                            filterOption={FilterOptions}
                            onChange={(e) => handleAddSelectedProduto(e)}
                            theme={Theme}
                            className='hideinputnewproduto_F0rm102023'
                            placeholder={ordemServ.codigo && !produtos.length && !searchingProduto ? <div className={stylesprintformulario.alertselectdisabled}>Não é possível selecionar mais serviços, pois a OS está com status 'Liberada' ou 'Cancelada'.</div> : 'Selecione um Produto'}
                            noOptionsMessage={() => "Nenhuma Opção"}
                            menuPosition='absolute'
                            onFocus={e => removeAlertErro('selectedProdutos')}
                            isDisabled={ordemServ.codigo && !produtos.length}
                        />
                    </div>
                    <div className='columntableprodutototal_F0rm102023'></div>
                    <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableprodutototal_F0rm102023'].join(' ')}>
                        <div className={[stylesprintformulario.bodycardlabel, stylesprintformulario.totaltableproduto].join(' ')}>TOTAL:</div>
                    </div>
                    <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableprodutototal_F0rm102023'].join(' ')}>
                        <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023', 'inputalignright_F0rm102023'].join(' ')} 
                            value={renderSumValorTotalProdutos().toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 })} readOnly={true}
                        />
                    </div>
                </div>
            )
        } else {
            return (
                <>
                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_34_10_6_6_9_15_20_auto, 'hideinputnewproduto_F0rm102023'].join(' ')}>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <label className={[stylesprintformulario.searchcard, stylesprintformulario.searchcarddefaultinput, 'searchcard_F0rm102023'].join(' ')} htmlFor='inputsearchproduto' onFocus={e => removeAlertErro('selectedProdutos')}>
                                <input type='text' id='inputsearchproduto' className={[stylesprintformulario.bodycardinput, stylesprintformulario.searchcardinput, 'bodycardinput_F0rm102023'].join(' ')} placeholder='Pesquisar código' autoComplete='off'
                                    value={inputSearchProduto || ''} onChange={e => setInputSearchProduto(changeInputValue(e.target, 15, 'number'))}
                                    onKeyDown={(e) => {if(e.key === 'Enter') {searchProdutoByCodigo()}}} title="Pressione 'Enter' para pesquisar"
                                />
                                <BsSearch className={stylesprintformulario.searchcardicon} onClick={() => setModalSearchProduto(true)} /> 
                            </label>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} readOnly={true}/>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} readOnly={true}/>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} readOnly={true}/>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} readOnly={true}/>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} readOnly={true}/>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} readOnly={true}/>
                        </div>
                    </div>
                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_44_21_15_20, 'linetableproduto_F0rm102023'].join(' ')}>
                        <div className='columntableprodutototal_F0rm102023'></div>
                        <div className='columntableprodutototal_F0rm102023'></div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableprodutototal_F0rm102023'].join(' ')}>
                            <div className={[stylesprintformulario.bodycardlabel, stylesprintformulario.totaltableproduto].join(' ')}>TOTAL:</div>
                        </div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableprodutototal_F0rm102023'].join(' ')}>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023', 'inputalignright_F0rm102023'].join(' ')} 
                                value={renderSumValorTotalProdutos().toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 })} readOnly={true}
                            />
                        </div>
                    </div>
                </>
            )
        }
    }

    function renderCardProdutos() {
        return (
            <div className={[stylesprintformulario.card, 'card_F0rm102023'].join(' ')} style={{zIndex: 2}} id='selectedProdutos'>
                {renderCardBeforeSearch(ordemServ, searchingProduto, produtos, ![0].includes(capaFormulario.tipo))}
                <div className={[stylesprintformulario.titlecard, 'titlecard_F0rm102023'].join(' ')}>
                    PRODUTOS/SERVIÇOS:
                </div>
                <div className={[stylesprintformulario.bodycard, 'bodycard_F0rm102023'].join(' ')}>
                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_34_10_6_6_9_15_20_auto, stylesprintformulario.titletableproduto, 'linetableproduto_F0rm102023'].join(' ')}>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>PRODUTO</div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>PESO</div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>UND.</div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>CFOP</div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>QTD.</div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>VLR. UNIT.</div>
                        <div className={[stylesprintformulario.columnbodycard, stylesprintformulario.columnbodycardtable, 'columntableproduto_F0rm102023'].join(' ')}>VLR. TOTAL</div>
                    </div>
                    {renderSelectedProdutos()}
                    {renderSelectProduto()}
                </div>
            </div>
        )
    }

    function renderInputRadioResponsavelFrete() {
        return (
            selectResponsavelFrete.items.map((responsavel, index) => {
                return (
                    <div className={stylesprintformulario.conteinerradio} onClick={() => setSelectResponsavelFrete(changeSelectValue(selectResponsavelFrete, responsavel.value))} key={index}>
                        <div className={stylesprintformulario.conteinericonradio}>
                            (
                                <div className={selectResponsavelFrete.selectItem === responsavel.value ? stylesprintformulario.showiconradio : stylesprintformulario.hideiconradio}>
                                    X
                                </div>
                            )
                        </div>
                        <div>{responsavel.label}</div>
                    </div>
                )
            })
        )
    }

    function renderInputSearchTransportador() {
        if(!capaFormulario.status && selectTipoFrete.selectItem === 2) {
            return (
                <label className={[stylesprintformulario.searchcard, 'searchcard_F0rm102023'].join(' ')} htmlFor='inputsearchtransportador' onFocus={e => removeAlertErro('transportador')}>
                    <input id='inputsearchtransportador' className={stylesprintformulario.searchcardinput} placeholder='Pesquisar código' autoComplete='off'
                        value={inputSearchTransportador || ''} onChange={e => setInputSearchTransportador(changeInputValue(e.target, 15, 'number'))}
                        onKeyDown={(e) => {if(e.key === 'Enter') {searchTransportadorByCodigo()}}} title="Pressione 'Enter' para pesquisar"
                    />
                    <BsSearch className={stylesprintformulario.searchcardicon} onClick={() => setModalSearchTransportador(true)} /> 
                </label>
            )
        }
    }

    function handleSelectTipoFrete(newSelectValue) {
        if(!history.location.state.id_formulario_os_capa && selectTipoFrete.selectItem !== newSelectValue) {
            if(selectTipoFrete.selectItem === 1) {
                removeAlertErro('inputNomeMotoristaTransportador');
                removeAlertErro('inputCpfMotoristaTransportador');
                removeAlertErro('inputTelefoneMotoristaTransportador');
            } else if(selectTipoFrete.selectItem === 2) {
                removeAlertErro('transportador');
                setTransportador({});
                setInputCidadeUfTransportador('');
                setInputTelefoneTransportador('');
                setInputVeiculoTransportador('');
                setInputPlacaTransportador('');
                setInputNomeResponsavelFrete('');
            }

            if(newSelectValue === 0) {
                setSelectResponsavelFrete(changeSelectValue(selectResponsavelFrete, 0));
                setInputNomeMotoristaTransportador('');
                setInputCpfMotoristaTransportador('');
                setInputTelefoneMotoristaTransportador('');
            }

            setSelectTipoFrete(changeSelectValue(selectTipoFrete, newSelectValue));
        }
    }

    function renderInputRadioTipoFrete() {
        return (
            selectTipoFrete.items.map((tipo, index) => {
                return (
                    <div className={[stylesprintformulario.conteinerradio, (history.location.state.id_formulario_os_capa ? (history.location.state.id_formulario_os_capa && selectTipoFrete.selectItem !== tipo.value ? stylesprintformulario.conteinerradiodisabled : '') : stylesprintformulario.conteinerradioactive)].join(' ')}
                        onClick={() => handleSelectTipoFrete(tipo.value)} key={index}
                    >
                        <div className={stylesprintformulario.conteinericonradio}>
                            (
                                <div className={selectTipoFrete.selectItem === tipo.value ? stylesprintformulario.showiconradio : stylesprintformulario.hideiconradio}>
                                    X
                                </div>
                            )
                        </div>
                        <div>{tipo.label}</div>
                    </div>
                )
            })
        )
    }

    function renderCardTipoFrete() {
        return (
            <div className={[stylesprintformulario.bodycardexterno, 'bodycardexternonone_F0rm102023'].join(' ')}>
                <div className={stylesprintformulario.columnbodycard}>
                    <div className={stylesprintformulario.bodycardlabel}>TIPO DO FRETE:</div>
                    <div className={stylesprintformulario.bodycardinputradio}>
                        {renderInputRadioTipoFrete()}
                    </div>
                </div>
            </div>
        )
    }

    function renderCardTransportadorTransportadora() {
        if(selectTipoFrete.selectItem === 2) {
            return (
                <>
                    <div className={stylesprintformulario.linebodycard}>
                        <div className={stylesprintformulario.columnbodycard} id='inputNomeResponsavelFrete'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>NOME DO RESPONSÁVEL PELA NEGOCIAÇÃO DO FRETE:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputNomeResponsavelFrete} onChange={e => setInputNomeResponsavelFrete(changeInputValue(e.target, 50))} onFocus={e => removeAlertErro('inputNomeResponsavelFrete')}
                            />
                        </div>
                    </div>
                    
                    <div className={stylesprintformulario.columnbodycardsubtitle}>
                        DADOS DA TRANSPORTADORA
                    </div>
                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_70_30].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>TRANSPORTADOR:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={transportador.codigo ? `${transportador.codigo} - ${transportador.descricao}` : ''} readOnly={true}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard}>
                            <div className={stylesprintformulario.bodycardlabel}>CNPJ/CPF:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} 
                                value={maskCpfCnpj(transportador.cnpj || '')} readOnly={true}
                            />
                        </div>
                    </div>

                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_50].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard} id='inputCidadeUfTransportador'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>CIDADE/UF:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputCidadeUfTransportador} onChange={e => setInputCidadeUfTransportador(changeInputValue(e.target, 50))} onFocus={e => removeAlertErro('inputCidadeUfTransportador')}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard} id='inputTelefoneTransportador'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>TELEFONE:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                value={inputTelefoneTransportador} onChange={e => setInputTelefoneTransportador(changeInputValue(e.target, 20, 'phone'))} onFocus={e => removeAlertErro('inputTelefoneTransportador')}
                            />
                        </div>
                    </div>

                    <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_80_20].join(' ')}>
                        <div className={stylesprintformulario.columnbodycard} id='inputVeiculoTransportador'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>VEÍCULO:</div>
                            <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                value={inputVeiculoTransportador} onChange={e => setInputVeiculoTransportador(changeInputValue(e.target, 50))} onFocus={e => removeAlertErro('inputVeiculoTransportador')}
                            />
                        </div>
                        <div className={stylesprintformulario.columnbodycard} id='inputPlacaTransportador'>
                            <div /><span />
                            <div className={stylesprintformulario.bodycardlabel}>PLACA:</div>
                            <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                value={inputPlacaTransportador} onChange={e => setInputPlacaTransportador(changeInputValue(e.target, 8, 'placa'))} onFocus={e => removeAlertErro('inputPlacaTransportador')}
                            />
                        </div>
                    </div>
                </>
            )
        }
    }

    function renderCardTransportador() {
        if(selectTipoFrete.selectItem !== 0) {
            return (
                <>
                    <div className={[stylesprintformulario.card, 'card_F0rm102023'].join(' ')} id='transportador'>
                        {renderCardBeforeSearch(transportador, searchingTransportador, undefined, false, selectTipoFrete.selectItem === 1)}
                        <div className={[stylesprintformulario.titlecard, 'titlecard_F0rm102023'].join(' ')}>
                            DADOS DO FRETE/TRANSPORTE:
                            {renderInputSearchTransportador()}
                        </div>
                        <div className={[stylesprintformulario.bodycard, 'bodycard_F0rm102023'].join(' ')}>
                            <div className={stylesprintformulario.linebodycard}>
                                <div className={stylesprintformulario.columnbodycard}>
                                    <div className={stylesprintformulario.bodycardlabel}>RESPONSÁVEL PELO FRETE:</div>
                                    <div className={stylesprintformulario.bodycardinputradio}>
                                        {renderInputRadioResponsavelFrete()}
                                    </div>
                                </div>
                            </div>

                            {renderCardTransportadorTransportadora()}

                            <div className={stylesprintformulario.columnbodycardsubtitle}>
                                DADOS DO MOTORISTA
                            </div>
                            <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_70_30].join(' ')}>
                                <div className={stylesprintformulario.columnbodycard} id='inputNomeMotoristaTransportador'>
                                    <div /><span />
                                    <div className={stylesprintformulario.bodycardlabel}>NOME:</div>
                                    <textarea rows={1} className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} ref={(e) => { if(e) {changeHeight(e)} }}
                                        value={inputNomeMotoristaTransportador} onChange={e => setInputNomeMotoristaTransportador(changeInputValue(e.target, 50))} onFocus={e => removeAlertErro('inputNomeMotoristaTransportador')}
                                    />
                                </div>
                                <div className={stylesprintformulario.columnbodycard} id='inputCpfMotoristaTransportador'>
                                    <div /><span />
                                    <div className={stylesprintformulario.bodycardlabel}>CPF:</div>
                                    <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                        value={inputCpfMotoristaTransportador} onChange={e => setInputCpfMotoristaTransportador(changeInputValue(e.target, 14, 'cpf'))} onFocus={e => removeAlertErro('inputCpfMotoristaTransportador')}
                                    />
                                </div>
                            </div>

                            <div className={[stylesprintformulario.linebodycard, stylesprintformulario.linebodycard_50_50].join(' ')}>
                                <div className={stylesprintformulario.columnbodycard} id='inputTelefoneMotoristaTransportador'>
                                    <div /><span />
                                    <div className={stylesprintformulario.bodycardlabel}>TELEFONE:</div>
                                    <input type='text' className={[stylesprintformulario.bodycardinput, 'bodycardinput_F0rm102023'].join(' ')} autoComplete='off'
                                        value={inputTelefoneMotoristaTransportador} onChange={e => setInputTelefoneMotoristaTransportador(changeInputValue(e.target, 20, 'phone'))} onFocus={e => removeAlertErro('inputTelefoneMotoristaTransportador')}
                                    />
                                </div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
    }

    function renderAssinaturas() {
        return (
            <div className={stylesprintformulario.conteinerassinaturas}>
                <div className={stylesprintformulario.lineassinatura}>
                    <div className={stylesprintformulario.columnassinatura}>
                        RESPONSÁVEL ÁREA
                    </div>
                    <div className={stylesprintformulario.columnassinatura}>
                        ALMOXARIFADO
                    </div>
                </div>
                <div className={stylesprintformulario.lineassinatura}>
                    <div className={stylesprintformulario.columnassinatura}>
                        GERENTE ÁREA
                    </div>
                    <div className={stylesprintformulario.columnassinatura}>
                        COMPRADOR
                    </div>
                </div>
            </div>
        )
    }

    function renderNewFormulario() {
        return (
            <div id='printFormulario' className={stylesprintformulario.conteinerformulario}>
                <div className='breakblock'>
                    <div className={stylesprintformulario.conteinerheaderformulario}>
                        <div className={stylesprintformulario.conteinerlogodoc}>
                            <div className={stylesprintformulario.conteinerheaderlogotitle}>
                                <div className={stylesprintformulario.conteinerheaderlogo}>
                                    <img src={`data:image/png;base64,${empresa.logo}`} alt='Logo da Empresa' className={stylesprintformulario.logo} />
                                </div>
                                <div>{empresa.razao_social}</div>
                            </div>
                            <div className={stylesprintformulario.conteinerheaderdocdata}>
                                N° DOCUMENTO: {capaFormulario.id.toString().padStart(6, '0')}
                            </div>
                        </div>
                        <div className={[stylesprintformulario.conteinerheaderdocdata, stylesprintformulario.conteinerheaderdata].join(' ')}>
                            {moment(capaFormulario.data_hora_digitacao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm')}
                        </div>
                    </div>
                    <div className={stylesprintformulario.conteinertitleformulario}>
                        {renderTitleTipoOs()}
                    </div>
                </div>

                <div className='breakblock'>
                    {/* EMPRESA */}
                    {renderCardEmpresa()}
                </div>

                <div className='breakblock'>
                    {/* FORNECEDOR */}
                    {renderCardFornecedor()}
                </div>

                <div className='breakblock'>
                    {/* ORDERM SERVIÇO */}
                    {renderCardOrdemServ()}
                </div>

                <div className='breakblock'>
                    <div className={stylesprintformulario.conteineralertdocumento}>
                        <GoAlert className={stylesprintformulario.iconalertdocumento}/>
                        <div className={stylesprintformulario.textalertdocumento}>
                            AVISO! ESSE DOCUMENTO NÃO AUTORIZA A REALIZAÇÃO DOS SERVIÇOS. (SOMENTE O SETOR DE SUPRIMENTOS PODERÁ AUTORIZAR A REALIZAÇÃO DO SERVIÇO MEDIANTE ORDEM DE COMPRA/PEDIDO)
                        </div>
                    </div>
                    {/* PRODUTOS/SERVICOS */}
                    {renderCardProdutos()}
                </div>

                <div className='breakblock'>
                    {renderCardTipoFrete()}
                    {/* TRANSPORTADOR */}
                    {renderCardTransportador()}
                </div>

                <div className='breakblock'>
                    {/* ASSINATURAS */}
                    {renderAssinaturas()}
                </div>
            </div>
        )
    }

    function renderFormulario() {
        if(!loading && capaFormulario.id && empresa.id) {
            return (
                <>
                    <div className={stylesformulario.conteinerformulario}>
                        <div className={stylesformulario.conteinerformulariopage}>
                            {renderNewFormulario()}
                        </div>
                    </div>
                    {renderButtonImprimir()}
                </>
            )
        }
    }

    function renderLoading() {
        if(loading || printing || loadingAfterPrint) {
            return (
                <div className={[swalstyles.conteiner, swalstyles.conteinerloading].join(' ')}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            {renderModalSearch()}
            {renderLoading()}
            <div className="container-lg">
                <Header title="FORMULÁRIO DE ORÇAMENTO" />
                {renderFormulario()}
            </div>
        </>
    )
}